<template>
    <div class="modal fade" id="cancelOrderModal" tabindex="-1" aria-labelledby="cancelOrderModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <Form :validation-schema="schema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancel Order</h5>
                        <!-- <button type="button" class="btn-close" @click="hideModal"></button> -->
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label">Reason for Canceling Order</label>
                            <Field 
                                name="comment" 
                                as="textarea" 
                                rows="3"
                                class="form-control" 
                                id="reasonInput" 
                                placeholder="Enter reason for canceling order"
                                :class="{ 'is-invalid': errors.comment }"
                                v-model="orderData.comment"
                            />
                            <div v-if="errors.comment" class="is-invalid invalid-feedback">{{ errors.comment }}</div>
                        </div>
                        <p>Are you sure you want to cancel this order?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="hideModal">Cancel</button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-theme"
                            :disabled="processing"
                            :class="{'disabled': processing}"
                            v-text="processing ? 'Processing...' : 'Yes, Confirm'"
                            @click="handleSubmit($event, updateOrder)"
                        ></button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CancelOrder",
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            processing: false,
            orderData: {
                id: this.order.id,
                status: "declined",
                comment: ''
            }
        };
    },
    computed: {
        schema() {
            return {
                comment: 'required'
            };
        }
    },
    methods: {
        updateOrder() {
            this.processing = true;
            axios
                .post('/api/admin/orders/update-status', {
                    order_id: this.order.id,
                    status: "canceled",
                    comment: this.orderData.comment,
                    action: "cancel_order"
                })
                .then(response => {
                    // Hide the modal
                    $('#cancelOrderModal').modal('hide');
                    
                    // Show success notification
                    this.$notification(response.data.status, response.data.message);

                    // Emit event to parent component
                    this.$emit('order-updated');

                    // Emit event to refresh the order list
                    this.$emitter.emit('refresh-order-list', {order: this.order});
                })
                .catch(error => {
                    this.$notification("error", error.response.data.message);
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        showModal() {
            $("#cancelOrderModal").modal("show");
        },
        hideModal() {
            $("#cancelOrderModal").modal("hide");

            this.$emitter.emit('reset-selected-order');
        }
    }
}
</script>